import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import ui from './ui';
import dash from './dash';
import auth from './auth';
import serviceForm from './serviceForm';
import locals from './locals';
import task from './task';
import pro from './pro';
import chat from './chat';
import menu from './menu';
import companyResponsibility from './companyResponsibility';
import notification from './notification';

const reducer = history => combineReducers({
  router: connectRouter(history),
  ui,
  auth,
  serviceForm,
  locals,
  task,
  pro,
  chat,
  dash,
  menu,
  notification,
  companyResponsibility,
});

export default reducer;
